import axios from "axios";

const state = {
    appointments: []
};
const getters = {
    appointments: state => {
        return state.appointments
    }
};
const actions = {
    createAppointment({commit}, {appointment,zone}) {
        const moment = require('moment-timezone')
        const name = appointment.name.replace("Available:", "Appointment:")
        const startLocal=moment(appointment.start).format()
        const endLocal=moment(appointment.end).format()
        const startTz = moment(startLocal).tz(zone,true).format()
        const endTz = moment(endLocal).tz(zone,true).format()
        const startUtc = moment(startTz).utc().format('YYYY-MM-DD HH:mm')
        const endUtc = moment(endTz).utc().format('YYYY-MM-DD HH:mm')
        axios.post('/api/appointments', {
            start:startUtc,
            end: endUtc,
            name: name,
            assignmentId: appointment.assignment_id
         })
            .then(res => {
                commit('CREATE_APPOINTMENT', res.data)
            }).catch(err => {
            console.log(err)
        })
    },
    fetchApointments({commit}, {id,zone}) {
        axios.get('/api/appointments/'+id)
            .then(res => {
                var data = res.data;
                var i = 0;
                for (i; i < res.data.length; i++) {
                    const moment = require('moment-timezone')
                    var startUtc = moment.utc(data[i].start).format()
                    var endUtc = moment.utc(data[i].end).format()
                    var startZone= moment(startUtc).tz(zone).format('YYYY-MM-DD HH:mm')
                    var endZone= moment(endUtc).tz(zone).format('YYYY-MM-DD HH:mm')    
                    data[i].start = moment(startZone).valueOf();
                    data[i].end =moment(endZone).valueOf();
                    data[i]['timed']=true;
                }
                commit('FETCH_APPOINTMENTS', data)
            }).catch(err => {
            console.log(err)
        })
    },
    deleteAppointment({commit}, appointment) {
        axios.delete('/api/appointments/'+appointment.id)
            .then(res => {
                commit('DELETE_APPOINTMENT', appointment)
            }).catch(err => {
            console.log(err)
        })
    },
    updateAppointment({commit}, {appointment,zone}) {
        const moment = require('moment-timezone')
        const startLocal=moment(appointment.start).format()
        const endLocal=moment(appointment.end).format()
        const startTz = moment(startLocal).tz(zone,true).format()
        const endTz = moment(endLocal).tz(zone,true).format()
        const startUtc = moment(startTz).utc().format('YYYY-MM-DD HH:mm')
        const endUtc = moment(endTz).utc().format('YYYY-MM-DD HH:mm')
        axios.post('/api/appointments/'+appointment.id , {
            start:startUtc,
            end: endUtc,
            name: appointment.name,
        })
            .then(res => {
                commit('UPDATE_APPOINTMENT', availability)
            }).catch(err => {
            console.log(err)
        })
    }
};
const mutations = {
    CREATE_APPOINTMENT(state, appointment) {
        state.appointments.unshift(appointment)
    },

    UPDATE_APPOINTMENT(state, appointment) {
        const elementsIndex = state.appointments.findIndex(item => item.id === appointment.id)
        state.appointments[elementsIndex] = appointment
    },
   
    FETCH_APPOINTMENTS(state, appointments) {
        return state.appointments = appointments
    },
    DELETE_APPOINTMENT(state, appointment) {
        let index = state.appointments.findIndex(item => item.id === appointment.id)
        state.appointments.splice(index, 1)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
